import {
  useCreateLocationListExclusionMutation,
  useDeleteLocationListExclusionMutation,
} from '@components/Dashboard/CampaignAnalytics/slice/campaignAnalyticsSlice';
import { LocationListExclusion } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { Switch } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

type LocationListEditorProps = {
  locationListExclusionId: LocationListExclusion['id'] | null;
  locationId: LocationListExclusion['locationId'] | null;
  locationListId: LocationListExclusion['locationListId'] | null;
};

export const LocationListEditor = (props: LocationListEditorProps) => {
  const { locationListExclusionId, locationId, locationListId } = props;
  const [createLocationListExclusion] =
    useCreateLocationListExclusionMutation();
  const [deleteLocationListExclusion] =
    useDeleteLocationListExclusionMutation();

  const onChange = async () => {
    const request = locationListExclusionId
      ? () => deleteLocationListExclusion(locationListExclusionId)
      : () => {
          if (!locationId || !locationListId)
            throw new Error('Missing locationId or locationListId');

          return createLocationListExclusion({
            locationId,
            locationListId,
          });
        };

    try {
      await request().unwrap();
      enqueueSnackbar('Location list updated', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error updating location list', { variant: 'error' });
    }
  };

  return (
    <Switch
      checked={!locationListExclusionId}
      onChange={() => void onChange()}
      disabled={!locationId || !locationListId}
    />
  );
};
